import React from "react";
import StripeConnectButton from "./StripeConnectButton";

interface SimulationTeaserProps {
  disabled?: boolean;
  testMode: boolean;
  text: string;
}

const SimulationTeaser = (props: SimulationTeaserProps) => {
  if (props.disabled) {
    return null;
  }

  return (
    <div className="relative bg-blue-50">
      <div className="h-56 bg-indigo-600 sm:h-72 md:absolute md:left-0 md:h-full md:w-1/2">
        <img
          src={require("../../img/illustrations/charts_guy.svg")}
          alt="Get results"
          className="pt-4 w-full h-full object-cover"
        />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <div className="md:ml-auto md:w-1/2 md:pl-10">
          <h2 className="text-base font-semibold uppercase tracking-wider text-gray-900">
            Analytics & Insights
          </h2>
          <p className="mt-2 text-gray-800 text-3xl font-extrabold tracking-tight sm:text-4xl">
            Are one click away
          </p>
          <p className="mt-3 text-lg text-gray-700">
            The data you are seeing is a sample.
          </p>
          <p className="mt-3 text-lg text-gray-700">{props.text}</p>
          <div className="mt-8">
            <div className="inline-flex rounded-md shadow">
              <StripeConnectButton
                scope="read_write"
                text={
                  !props.testMode
                    ? "Connect to Stripe"
                    : "Connect to Stripe Test"
                }
                testMode={props.testMode}
                redirectAfterSuccess={window.location.href}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimulationTeaser;
